import { Component, forwardRef, Inject } from '@angular/core';
import { Events } from 'ionic-angular';
import { ComponentServiceProvider } from '../../providers/component-service/component-service';
import { DataServiceProvider } from '../../providers/data-service/data-service';

@Component({
  selector: 'proposal',
  templateUrl: 'proposal.html'
})
export class ProposalComponent {

  headerValues = {
    buttonLabel: [{
      "name": "return",
      "action": 'return'
    }]
  };
  TableContent: any = [];
  constructor(public event: Events, public dataService: DataServiceProvider, @Inject(forwardRef(() => ComponentServiceProvider)) public componentService: ComponentServiceProvider) {
  }

  ngOnInit() {
    this.dataService.broadcastInfo({ src: 'proposal-create', event: 'PAGE_HEADER', status: true, params: this.headerValues});
  }
  selectTable(idx, event) {
    this.dataService.TableContent[idx].IsChecked = event.target.checked;
    if (this.dataService.TableContent[idx].IsChecked == true) {
      var index = [];
      let table = this.dataService.TableContent.slice(0, idx);
      table.forEach(element => {
        if (element.IsChecked == true) {
          index.push(element);
        }
      });
      var ind: any;
      for (var i = idx; i < this.dataService.TableContent.length; i++) {
        if (index.length == 0) {
          this.dataService.TableContent[i].pageNo = ind + 1;
          ind = this.dataService.TableContent[i].pageNo;
        } else {
          if(index[index.length - 1].SectionId == 'Cover-Letter'){
            this.dataService.TableContent[i].pageNo = index[index.length - 1].pageNo + 2;
          }else{
            this.dataService.TableContent[i].pageNo = index[index.length - 1].pageNo + 1;
          }
          ind = this.dataService.TableContent[i].pageNo;
          index = [];
        }
      }
    } else {
      var len = this.dataService.TableContent[idx].pageNo;
      this.dataService.TableContent[idx].pageNo = 0;
      for (var i = idx + 1; i < this.dataService.TableContent.length; i++) {
        this.dataService.TableContent[i].pageNo = len;
        len = this.dataService.TableContent[i].pageNo + 1;
      }
    }
  }
  ngAfterViewChecked() {
    localStorage.setItem('TableContent', JSON.stringify(this.dataService.TableContent));
  }

  ngAfterViewInit() {
    var tableCont = JSON.parse(localStorage.getItem('TableContent'));
    if (tableCont != null) {
      this.dataService.TableContent = tableCont;
    }
     document.getElementById('pageWidth').scrollIntoView();
  }

  ngOnDestroy() {
  }
}



// WEBPACK FOOTER //
// ./src/components/proposal/proposal.ts